import React from 'react';

type HookArgs = any | any[] | null;
type HookResponse = any | any[] | null;

const withHook = <P extends object>(
  WrappedComponent: React.ComponentType<P>,
  hookName: string,
  hook: (...args: HookArgs) => HookResponse,
  hookArgs?: HookArgs | ((props: P) => HookArgs),
) => {
  const WithHook = (props: P) => {
    let hookArgsToPass = [];

    if (typeof hookArgs === 'function') {
      hookArgsToPass = hookArgs(props);
    } else if (hookArgs) {
      hookArgsToPass = hookArgs;
    }

    const hookResponse = hook(...hookArgsToPass);
    const combinedProps = { ...props, [hookName]: hookResponse };

    return (
      <WrappedComponent {...combinedProps} />
    );
  };

  // eslint-disable-next-line react/forbid-foreign-prop-types
  const propTypes = { ...WrappedComponent.propTypes };
  delete propTypes[hookName];
  WithHook.propTypes = propTypes;
  WithHook.defaultProps = WrappedComponent.defaultProps;

  return WithHook;
};

export default withHook;
